import { ThemeColors } from "@/constants/theme";
import { useTheme } from "@/contexts/ThemeContext";

export function useThemeColor(
  props: { light?: string; dark?: string },
  colorName: ThemeColors
) {
  const { theme: themeColors, colorScheme } = useTheme();
  const colorFromProps = props[colorScheme];

  if (colorFromProps) {
    return colorFromProps;
  }

  return themeColors[colorName];
}
